/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Point } from 'pixi.js-legacy';

export enum LineStyle {
	solid = 'solid',
	dashed = 'dashed',
}

export class SpacialPoint extends Point {
	public xIsScreen = false;
	public yIsScreen = false;
}

export class Line {
	constructor(startPoint: Point | number, endPoint: Point | number, endX?: number, endY?: number) {
		if (endX) {
			this.start = new SpacialPoint(startPoint as number, endPoint as number);
			this.end = new SpacialPoint(endX, endY);
		} else {
			this.start = startPoint as SpacialPoint;
			this.end = endPoint as SpacialPoint;
		}
	}

	public start: SpacialPoint;
	public end: SpacialPoint;
	public text?: string;

	public color = 0x2176ae;
	public lineStyle = LineStyle.solid;
	public static clone(line: Line) {
		let l = new Line(line.start, line.end);
		l.color = line.color;
		l.lineStyle = line.lineStyle;
		l.text = line.text;
		return l;
	}
}
